module.exports = __webpack_public_path__ + "img/spring_trip-20160416-20.889b06a4.jpg";